<div class="wrapper">
  <div id="arChart" [ngClass]="{'special': (showPlaceholder$ | async)}" #arChart></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>AR graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
    </div>
  }
</div>